import axios from 'axios';
import config from '../../../config';

const domain = config.api_domain.domain

const LoaderUtilsService2 = async (endpoint) => {
    try {
        const url = (`${domain}/${endpoint}`)
        const res = await axios.get(url)
        return res.data.body
        
    } catch (error) {
        console.error(error);
        return null;
    }
}

export default LoaderUtilsService2